<template>
  <div class="AfterSingle" style="margin-bottom:50px;">
      <el-form ref="form" label-width="100px">
          <el-col :span="4">
                <el-form-item label="状态" prop="startTimeString">
                  <el-select v-model="form.state" placeholder="请选择">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="5">
                <el-form-item label="开始日期" prop="startTimeString">
                    <el-date-picker
                        @change="startTime"
                        v-model="form.startTimeString"
                        align="right"
                        type="date"
                        placeholder="选择开始日期"
                        format="yyyy-MM-dd HH:mm:ss"
                    ></el-date-picker>
                </el-form-item>
            </el-col>
            <el-col :span="5">
                <el-form-item label="结束日期" prop="endTimeString">
                    <el-date-picker
                        @change="endTime"
                        v-model="form.endTimeString"
                        align="right"
                        type="date"
                        placeholder="选择结束日期"
                        format="yyyy-MM-dd HH:mm:ss"
                    ></el-date-picker>
                </el-form-item>
            </el-col>
            <el-col :span="10">
                <el-form-item prop="searchInput">
                    <el-input
                        v-model.trim="form.searchString"
                        placeholder="国际运单号、订单ID"
                        style="width: 70%;"
                    ></el-input>
                    <el-button type="primary" @click="search" style="margin-left:10px;">搜索</el-button>
                    <el-button type="primary" @click="reset">重置</el-button>
                </el-form-item>
            </el-col>
      </el-form>
      <el-divider></el-divider>
      <el-button type="primary" @click="Creatsingle = true">新建售后</el-button>
        <el-table :data="tableData" border style="width: 100%;margin-top:15px;">
          <el-table-column prop="amazonOrderId" label="订单号" align="center" width="220"></el-table-column>
          <el-table-column prop="companyShortName" label="所属公司" align="center" width="220"></el-table-column>
          <el-table-column label="售后类型" align="center" width="150">
            <template slot-scope="scope">
              <span v-if="scope.row.afterSaleType == '其他'">{{scope.row.other}}</span>
              <span v-if="scope.row.afterSaleType != '其他'">{{scope.row.afterSaleType}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="documentNo" label="相关单据号" align="center"  width="220"></el-table-column>
          <el-table-column prop="actualRefundFee" label="售后费用" align="center"  width="150"></el-table-column>
          <el-table-column prop="afterSaleReason" label="售后原因" align="center"  width="300"></el-table-column>
          <el-table-column label="状态" align="center" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0" style="color:red;">未完成</span>
              <span v-if="scope.row.status == 1" style="color:green;">已完成</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" align="center" width="180"></el-table-column>
          <el-table-column label="提交时间" align="center" width="180">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0" style="color:red;">未完成</span>
              <span v-if="scope.row.status == 1">{{scope.row.submitTime}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="roleName" label="操作人" align="center" width="180"></el-table-column>
          <el-table-column label="操作" align="center" fixed="right"  width="150">
            <template slot-scope="scope">
              <el-button type="success" v-if="scope.row.status == 1" @click="ToView(scope.row)">查看</el-button>
              <el-button type="primary" v-if="scope.row.status == 0" @click="Edit(scope.row)">操作</el-button>
            </template>
          </el-table-column>
  </el-table>
  
  <div class="page">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[50, 100, 200, 400]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        ></el-pagination>
  </div>

  <el-dialog title="创建售后单" :visible.sync="Creatsingle" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" width="35%">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <el-row>
        <el-col :span="12">
        <el-form-item label="售后类型" prop="type">
          <el-select v-model="ruleForm.type" placeholder="请选择">
              <el-option
                v-for="item in AfterType"
                :key="item.value"
                :label="item.label"
                :value="item.label">
              </el-option>
          </el-select>
        </el-form-item>
        </el-col>

        <el-col :span="12">
          <div class="details">
          <el-form-item prop="other" v-if="this.ruleForm.type == '其他'">
            <el-input style="width:200px;margin-left:15px;" v-model="ruleForm.other"></el-input>
          </el-form-item>
          </div>
        </el-col>
      </el-row>
        
        <el-row>
          <el-col :span="12">
          <el-form-item label="公司选择" prop="branch">
            <el-select v-model="ruleForm.branch" placeholder="分公司" @change="selectbranch">
              <el-option
                    v-for="item in branchList"
                    :key="item.id"
                    :label="item.companyFullName"
                    :value="item.id">
                  </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <div class="details">
            <el-form-item prop="subsidiary">
              <el-select v-model="ruleForm.subsidiary" placeholder="子公司" style="width:200px;margin-left:15px;">
                <el-option
                  v-for="item in subsidiaryList"
                  :key="item.id"
                  :label="item.companyFullName"
                  :value="item.id">
                </el-option>
            </el-select>
          </el-form-item>
          </div>
          </el-col>
        </el-row>

        <el-form-item label="订单号" prop="orderId">
              <el-input style="width:415px;" v-model="ruleForm.orderId"></el-input>
        </el-form-item>

        <el-form-item label="相关单据" prop="documents">
              <el-input style="width:415px;" v-model="ruleForm.documents"></el-input>
        </el-form-item>

        <el-form-item label="售后原因" prop="AfterWhy">
              <el-input style="width:415px;" type="textarea" :autosize="{ minRows: 4, maxRows: 10}" v-model="ruleForm.AfterWhy"></el-input>
        </el-form-item>

        <el-form-item label="售后费用">
              <el-button type="primary" @click="queryCost">查询相关费用</el-button>
        </el-form-item>

        <el-table border style="width: 100%" :data="RelatedTable" v-show="this.isShow">
          <el-table-column prop="documentNo" label="扣费相关单据" align="center"></el-table-column>
          <el-table-column prop="type" label="扣费类型" align="center">
            <template slot-scope="scope">
                <span v-if="scope.row.type == 1">充值</span>
                <span v-if="scope.row.type == 2">运费预扣</span>
                <span v-if="scope.row.type == 3">收件费用</span>
                <span v-if="scope.row.type == 4">退件费用</span>
                <span v-if="scope.row.type == 5">分装费用</span>
                <span v-if="scope.row.type == 6">合装费用</span>
                <span v-if="scope.row.type == 7">包材费用</span>
                <span v-if="scope.row.type == 8">仓储费用</span>
                <span v-if="scope.row.type == 9">出库操作费</span>
                <span v-if="scope.row.type == 10">预扣运费回</span>
                <span v-if="scope.row.type == 11">运费实扣</span>
                <span v-if="scope.row.type == 12">平台费用</span>
                <span v-if="scope.row.type == 13">售后回退</span>
            </template>
          </el-table-column>
          <el-table-column prop="actualExpenses" label="扣费数额" align="center"></el-table-column>
        </el-table>
        
        <el-form-item label="费用总计">
              <span>{{this.actualExpensesTotal}}</span>
        </el-form-item>

        <el-form-item label="实际退费" prop="refund">
              <el-input style="width:215px;" v-model="ruleForm.refund"></el-input>
        </el-form-item>

    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="resetForm('ruleForm')">取 消</el-button>
      <el-button type="primary" @click="save('ruleForm')">保存</el-button>
      <el-button type="primary" @click="submit('ruleForm')">提交</el-button>
    </span>
  </el-dialog>

  <el-dialog title="编辑售后单" :visible.sync="Editsingle" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" width="35%">
    <el-form ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <el-row>
        <el-col :span="12">
        <el-form-item label="售后类型">
          <el-select v-model="ruleForm.type1" placeholder="请选择">
              <el-option
                v-for="item in AfterType"
                :key="item.value"
                :label="item.label"
                :value="item.label">
              </el-option>
          </el-select>
        </el-form-item>
        </el-col>

        <el-col :span="12">
          <div class="details">
          <el-form-item v-if="this.ruleForm.type1 == '其他'">
            <el-input style="width:200px;margin-left:15px;" v-model="ruleForm.other1"></el-input>
          </el-form-item>
          </div>
        </el-col>
      </el-row>
        
        <el-row>
          <el-col :span="12">
          <el-form-item label="公司选择">
            <el-select v-model="ruleForm.branch1" placeholder="分公司" @change="selectbranch1">
              <el-option
                    v-for="item in branchList"
                    :key="item.id"
                    :label="item.companyFullName"
                    :value="item.id">
                  </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <div class="details">
            <el-form-item>
              <el-select v-model="ruleForm.subsidiary1" placeholder="子公司" style="width:200px;margin-left:15px;">
                <el-option
                  v-for="item in subsidiaryList1"
                  :key="item.id"
                  :label="item.companyFullName"
                  :value="item.id">
                </el-option>
            </el-select>
          </el-form-item>
          </div>
          </el-col>
        </el-row>

        <el-form-item label="订单号">
              <el-input style="width:415px;" v-model="ruleForm.orderId1"></el-input>
        </el-form-item>

        <el-form-item label="相关单据">
              <el-input style="width:415px;" v-model="ruleForm.documents1"></el-input>
        </el-form-item>

        <el-form-item label="售后原因">
              <el-input style="width:415px;" type="textarea" :autosize="{ minRows: 4, maxRows: 10}" v-model="ruleForm.AfterWhy1"></el-input>
        </el-form-item>

        <el-form-item label="售后费用">
              <el-button type="primary" @click="queryCost1">查询相关费用</el-button>
        </el-form-item>

        <el-table border style="width: 100%" :data="RelatedTable" v-show="this.isShow1">
          <el-table-column prop="documentNo" label="扣费相关单据" align="center"></el-table-column>
          <el-table-column label="扣费类型" align="center">
            <template slot-scope="scope">
                <span v-if="scope.row.type == 1">充值</span>
                <span v-if="scope.row.type == 2">运费预扣</span>
                <span v-if="scope.row.type == 3">收件费用</span>
                <span v-if="scope.row.type == 4">退件费用</span>
                <span v-if="scope.row.type == 5">分装费用</span>
                <span v-if="scope.row.type == 6">合装费用</span>
                <span v-if="scope.row.type == 7">包材费用</span>
                <span v-if="scope.row.type == 8">仓储费用</span>
                <span v-if="scope.row.type == 9">出库操作费</span>
                <span v-if="scope.row.type == 10">预扣运费回</span>
                <span v-if="scope.row.type == 11">运费实扣</span>
                <span v-if="scope.row.type == 12">平台费用</span>
                <span v-if="scope.row.type == 13">售后回退</span>
            </template>
          </el-table-column>
          <el-table-column prop="actualExpenses" label="扣费数额" align="center"></el-table-column>
        </el-table>
        
        <el-form-item label="费用总计">
              <span>{{this.actualExpensesTotal}}</span>
        </el-form-item>

        <el-form-item label="实际退费" prop="refund">
              <el-input style="width:215px;" v-model="ruleForm.refund1"></el-input>
        </el-form-item>

    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="resetForm1">取 消</el-button>
      <el-button type="primary" @click="save1">保存</el-button>
      <el-button type="primary" @click="submit1">提交</el-button>
    </span>
  </el-dialog>

  <el-dialog title="查看售后单" :visible.sync="Viewsingle" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" width="35%">
    <el-form ref="ruleForm" label-width="100px" class="demo-ruleForm">

        <el-form-item label="售后类型：" prop="type">
          <span>{{this.ruleForm.type1}}</span>
        </el-form-item>
        
        <el-row>
          <el-col :span="12">
          <el-form-item label="公司选择：" prop="branch">
            <span>分公司：{{this.ruleForm.branch1}}</span>
          </el-form-item>
          </el-col>
          <el-col :span="12">
            <div class="details">
            <el-form-item prop="subsidiary">
              <span>子公司：{{this.ruleForm.subsidiary1}}</span>
            </el-form-item>
          </div>
          </el-col>
        </el-row>

        <el-form-item label="订单号：" prop="orderId">
              <span>{{this.ruleForm.orderId1}}</span>
        </el-form-item>

        <el-form-item label="相关单据：" prop="documents">
              <span>{{this.ruleForm.documents1}}</span>
        </el-form-item>

        <el-form-item label="售后原因：" prop="AfterWhy">
              <span>{{this.ruleForm.AfterWhy1}}</span>
        </el-form-item>

        <el-form-item label="售后费用：">
              <el-button type="primary" @click="queryCost1">查询相关费用</el-button>
        </el-form-item>

        <el-table border style="width: 100%" :data="RelatedTable" v-show="this.isShow1">
          <el-table-column prop="documentNo" label="扣费相关单据" align="center"></el-table-column>
          <el-table-column prop="type" label="扣费类型" align="center">
            <template slot-scope="scope">
                <span v-if="scope.row.type == 1">充值</span>
                <span v-if="scope.row.type == 2">运费预扣</span>
                <span v-if="scope.row.type == 3">收件费用</span>
                <span v-if="scope.row.type == 4">退件费用</span>
                <span v-if="scope.row.type == 5">分装费用</span>
                <span v-if="scope.row.type == 6">合装费用</span>
                <span v-if="scope.row.type == 7">包材费用</span>
                <span v-if="scope.row.type == 8">仓储费用</span>
                <span v-if="scope.row.type == 9">出库操作费</span>
                <span v-if="scope.row.type == 10">预扣运费回</span>
                <span v-if="scope.row.type == 11">运费实扣</span>
                <span v-if="scope.row.type == 12">平台费用</span>
                <span v-if="scope.row.type == 13">售后回退</span>
            </template>
          </el-table-column>
          <el-table-column prop="actualExpenses" label="扣费数额" align="center"></el-table-column>
        </el-table>
        
        <el-form-item label="费用总计：">
              <span>{{this.actualExpensesTotal}}</span>
        </el-form-item>

        <el-form-item label="实际退费：" prop="refund">
              <span>{{this.ruleForm.refund1}}</span>
        </el-form-item>

    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="resetForm2">关闭</el-button>
    </span>
  </el-dialog>

  </div>
</template>

<script>
import { ajaxPost, Baseurl } from "@/api/api/api";
export default {
  data() {
      return {
        id:"",
        str:"",
        tableData:[],
        RelatedTable:[],
        actualExpensesTotal:"",
        Creatsingle:false,
        Editsingle:false,
        Viewsingle:false,
        isTrue:"",
        form:{
            startTimeString:"",
            endTimeString:"",
            searchString:"",
            state:"",
        },
        isShow:false,
        isShow1:false,
        branchList:[],
        subsidiaryList:[],
        subsidiaryList1:[],
        ruleForm:{
          type:"",
          other:"",
          branch:"",
          subsidiary:"",
          orderId:"",
          documents:"",
          AfterWhy:"",
          refund:"",

          type1:"",
          other1:"",
          branch1:"",
          subsidiary1:"",
          orderId1:"",
          documents1:"",
          AfterWhy1:"",
          refund1:"",

          companyId:"",
        },

        currentPage: 1,
        pagesize: 50,
        size: 50,
        total: 0,

        options:[
          {
            value: 0,
            label: '未完成'
          },
          {
            value: 1,
            label: '已完成'
          },
        ],
        AfterType:[
          {
            value: 0,
            label: '运费退款'
          },
          {
            value: 1,
            label: '平台费退款'
          },
          {
            value: 2,
            label: '其他'
          },
        ],
        rules: {
          type: [
            { required: true, message: '请选择售后类型', trigger: 'blur' },
          ],
          other: [
            { required: true, message: '请填写其他售后类型', trigger: 'blur' },
          ],
          documents: [
            { required: false, message: '请填写售后原因', trigger: 'blur' },
          ],
          branch: [
            { required: true, message: '请选择分公司', trigger: 'blur' },
          ],
          subsidiary: [
            { required: true, message: '请选择子公司', trigger: 'blur' },
          ],
          orderId: [
            { required: true, message: '请输入订单号', trigger: 'blur' },
          ],
          AfterWhy: [
            { required: true, message: '请填写售后原因', trigger: 'blur' },
          ],
          refund: [
            { required: true, message: '请输入实际退费', trigger: 'blur' },
          ],
        },
      }
  },
  created(){
      this.str = JSON.parse(localStorage.getItem("role"));
      this.search();
      this.Allbranch();
  },
  methods: {
    search2(){
      this.currentPage = 1
      this.search()
    },
    search(){
      var obj = {
        page:this.currentPage,
        size:this.size,
        startTimeString:this.form.startTimeString,
        endTimeString:this.form.endTimeString,
        status:this.form.state,
        searchString:this.form.searchString
      }
      ajaxPost(Baseurl + "afterSaleController/selectAfterSaleList", obj).then(res => {
        if(res.data.code == 200){
            this.tableData = res.data.data.list;
            this.total = res.data.data.total;
        }
      });
    },
    reset(){
      this.form.startTimeString = ""
      this.form.endTimeString = ""
      this.form.searchString = ""
      this.form.state = ""
      this.search();
    },
    Allbranch(){
      ajaxPost(Baseurl + "logisticsController/getAllBranchCompany").then(res => {
        if(res.data.code == 200){
            this.branchList = res.data.data
        }
      });
    },
    selectbranch(){
      this.ruleForm.subsidiary = ""
      var obj = {
        id:this.ruleForm.branch
      }
      ajaxPost(Baseurl + "logisticsController/getAllSubCompanyById",obj).then(res => {
        if(res.data.code == 200){
            this.subsidiaryList = res.data.data
        }
      });
    },
    selectbranch1(){
      this.ruleForm.subsidiary1 = ""
      var obj = {
        id:this.ruleForm.branch1
      }
      ajaxPost(Baseurl + "logisticsController/getAllSubCompanyById",obj).then(res => {
        if(res.data.code == 200){
            this.subsidiaryList1 = res.data.data
        }
      });
    },
    queryCost(){
      this.RelatedTable = []
      var obj = {
        amazonOrderId:this.ruleForm.orderId,
        companyId:this.ruleForm.subsidiary
      }
      ajaxPost(Baseurl + "afterSaleController/selectDeductionDetailsByOrderId",obj).then(res => {
        if(res.data.code == 200){
          console.log(res.data.data)
            this.RelatedTable = res.data.data.deductionDetails
            this.actualExpensesTotal = res.data.data.actualExpensesTotal
        }
      });
      this.isShow = true
    },
    queryCost1(){
      this.RelatedTable = []
      var obj = {
        amazonOrderId:this.ruleForm.orderId1,
        companyId:this.ruleForm.companyId
      }
      ajaxPost(Baseurl + "afterSaleController/selectDeductionDetailsByOrderId",obj).then(res => {
        if(res.data.code == 200){
          console.log(res.data.data)
            this.RelatedTable = res.data.data.deductionDetails
            this.actualExpensesTotal = res.data.data.actualExpensesTotal
        }
      });
      this.isShow1 = true
    },
    submit(formName){
      this.$refs[formName].validate((valid) => {
            if (valid) {
              this.$confirm('提交之后确认售后退费完成', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                var obj = {
                  roleId:this.str.rid,
                  afterSaleType:this.ruleForm.type,
                  amazonOrderId:this.ruleForm.orderId,
                  other:this.ruleForm.other,
                  documentNo:this.ruleForm.documents,
                  afterSaleReason:this.ruleForm.AfterWhy,
                  actualRefundFee:this.ruleForm.refund,
                  status:1,
                  companyId:this.ruleForm.subsidiary,
                  fenCompanyId:this.ruleForm.branch,
                  id:""
                }
                ajaxPost(Baseurl + "afterSaleController/insertAfterSale",obj).then(res => {
                  if(res.data.code == 200){
                    this.$message({
                          type: 'success',
                          message: '提交成功!'
                    });
                    this.search()
                  }else{
                    this.$message.error(res.data.data)
                  }
                });
                this.Creatsingle = false
                this.actualExpensesTotal = ""
                this.isShow = false
                this.$refs[formName].resetFields();

              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消提交'
                });          
              });
            } else {
              return false;
            }
      });
    },
    save(formName){
      this.$refs[formName].validate((valid) => {
          if (valid) {
            var obj = {
              roleId:this.str.rid,
              afterSaleType:this.ruleForm.type,
              amazonOrderId:this.ruleForm.orderId,
              other:this.ruleForm.other,
              documentNo:this.ruleForm.documents,
              afterSaleReason:this.ruleForm.AfterWhy,
              actualRefundFee:this.ruleForm.refund,
              status:0,
              companyId:this.ruleForm.subsidiary,
              fenCompanyId:this.ruleForm.branch,
              id:""
            }
            ajaxPost(Baseurl + "afterSaleController/insertAfterSale",obj).then(res => {
              if(res.data.code == 200){
                this.$message({
                      type: 'success',
                      message: '保存成功!'
                });
                this.search()
              }else{
                this.$message.error(res.data.data)
              }
            });
            this.Creatsingle = false
            this.actualExpensesTotal = ""
            this.isShow = false
            this.$refs[formName].resetFields();
          } else {
            return false;
          }
        });
    },
    resetForm(formName){
      this.Creatsingle = false;
      this.isShow = false
      this.actualExpensesTotal = ""
      this.$refs[formName].resetFields();
    },

    submit1(){
              this.$confirm('提交之后确认售后退费完成', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                var obj = {
                  roleId:this.str.rid,
                  afterSaleType:this.ruleForm.type1,
                  amazonOrderId:this.ruleForm.orderId1,
                  other:this.ruleForm.other1,
                  documentNo:this.ruleForm.documents1,
                  afterSaleReason:this.ruleForm.AfterWhy1,
                  actualRefundFee:this.ruleForm.refund1,
                  status:1,
                  companyId:this.ruleForm.subsidiary1,
                  fenCompanyId:this.ruleForm.branch1,
                  id:this.id
                }
                ajaxPost(Baseurl + "afterSaleController/insertAfterSale",obj).then(res => {
                  if(res.data.code == 200){
                    this.$message({
                          type: 'success',
                          message: '提交成功!'
                    });
                    this.search()
                  }else{
                    this.$message.error(res.data.data)
                  }
                });
                this.isShow1 = false
                this.Editsingle = false
                this.actualExpensesTotal = ""
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消提交'
                });          
              });
    },
    save1(){
            var obj = {
              roleId:this.str.rid,
              afterSaleType:this.ruleForm.type1,
              amazonOrderId:this.ruleForm.orderId1,
              other:this.ruleForm.other1,
              documentNo:this.ruleForm.documents1,
              afterSaleReason:this.ruleForm.AfterWhy1,
              actualRefundFee:this.ruleForm.refund1,
              status:0,
              companyId:this.ruleForm.subsidiary1,
              fenCompanyId:this.ruleForm.branch1,
              id:this.id
            }
            ajaxPost(Baseurl + "afterSaleController/insertAfterSale",obj).then(res => {
              if(res.data.code == 200){
                this.$message({
                      type: 'success',
                      message: '保存成功!'
                });
                this.search()
              }else{
                this.$message.error(res.data.data)
              }
            });
            this.isShow1 = false
            this.Editsingle = false
            this.actualExpensesTotal = ""
    },
    resetForm1(){
      this.isShow1 = false
      this.Editsingle = false;
      this.actualExpensesTotal = ""
    },
    resetForm2(){
      this.isShow1 = false
      this.Viewsingle = false;
      this.actualExpensesTotal = ""
    },
    Edit(val){
      console.log(val)
      this.id = val.id
      this.Editsingle = true;

      this.ruleForm.type1 = val.afterSaleType
      this.ruleForm.orderId1 = val.amazonOrderId
      this.ruleForm.other1 = val.other
      this.ruleForm.documents1 = val.documentNo
      this.ruleForm.AfterWhy1 = val.afterSaleReason
      this.ruleForm.refund1 = val.actualRefundFee
      this.ruleForm.subsidiary1 = val.companyId
      this.ruleForm.branch1 = val.fenCompanyId

      this.ruleForm.companyId = val.companyId

      var obj = {
        id:this.ruleForm.branch1
      }
      ajaxPost(Baseurl + "logisticsController/getAllSubCompanyById",obj).then(res => {
        if(res.data.code == 200){
            this.subsidiaryList1 = res.data.data
        }
      });
    },
    ToView(val){
      console.log(val)
      this.ruleForm.type1 = val.afterSaleType
      this.ruleForm.orderId1 = val.amazonOrderId
      this.ruleForm.other1 = val.other
      this.ruleForm.documents1 = val.documentNo
      this.ruleForm.AfterWhy1 = val.afterSaleReason
      this.ruleForm.refund1 = val.actualRefundFee
      this.ruleForm.subsidiary1 = val.subCompanyName
      this.ruleForm.branch1 = val.fenCompanyName

      this.ruleForm.companyId = val.companyId
      this.Viewsingle = true;
    },
    startTime(val) {
            var d = new Date(val);
            var datetime = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate() + " 00:00:00";
            this.form.startTimeString = datetime;
    },
    endTime(val) {
            var d = new Date(val);
            var datetime = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate() + " 23:59:59";
            this.form.endTimeString = datetime;
    },
    handleSizeChange(val){
            this.size = val;
            this.search()
        },
    handleCurrentChange(val) {
            this.currentPage = val;
            this.search()
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/{
    .details .el-form-item__content{
        margin-left: -5px!important;
    }
    .details .el-form-item__error{
      left: 16px!important;
    }
}
</style>
<style lang="scss" scoped>
  .page {
      position: fixed;
      width: 80%;
      bottom: 0;
      background-color: white;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 50px;
  }
</style>